import { memo } from 'react'

import { LanguageProvider } from '@orus.eu/pharaoh/src/code-only/localization/language-context'

import { CurrentLanguageSyncForNotifications } from '../../lib/current-language-for-notifications.ts'
import { useSession } from '../../lib/session.ts'

import { DocumentLanguageSync } from './document-language-sync.tsx'

export const SessionLanguageProvider = memo<{ children: React.ReactNode }>(function SessionLanguageProvider({
  children,
}) {
  const session = useSession()

  const language = session.user?.language ?? session.language ?? undefined

  return (
    <LanguageProvider value={language}>
      <CurrentLanguageSyncForNotifications />
      <DocumentLanguageSync />
      {children}
    </LanguageProvider>
  )
})
